export default __webpack_public_path__ + "static/media/subspace.9b7bd4f2.png";